import React, { useEffect } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Option1 from './Option1';
import Option2 from './Option2';
import Option22 from './Option22';
import ConvertImageFromSheet from './ConvertImageFromSheet';
import ImageToFileFeed from './ImageToFileFeed';
import UploadMoreImages from './UploadMoreImages';
import Token from './Token';
import WooStoreProducts from './WooStoreProducts';
import QR from './QR';
import { useState } from 'react';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  AppBar,
  Typography,
  Button
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import LoadingScreen from './Loading';
import { delVa, getVa } from './features/slices';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import ImageIcon from '@mui/icons-material/Image';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import TableChartIcon from '@mui/icons-material/TableChart';
import FeedIcon from '@mui/icons-material/Feed';
import TransformIcon from '@mui/icons-material/Transform';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import StorefrontIcon from '@mui/icons-material/Storefront';
import QrCode2Icon from '@mui/icons-material/QrCode2';

const drawerWidth = 280;

const menuItems = [
  { id: 'Option1', label: 'Simple To Variable', icon: <TransformIcon /> },
  { id: 'Option2', label: 'Convert Images', icon: <ImageIcon /> },
  { id: 'Option22', label: 'Upload Images', icon: <UploadFileIcon /> },
  { id: 'UploadMoreImages', label: 'Upload More Images', icon: <CloudUploadIcon /> },
  { id: 'ConvertImageFromSheet', label: 'Sheet Image Convert', icon: <TableChartIcon /> },
  { id: 'ImageToFileFeed', label: 'Image To File Feed', icon: <FeedIcon /> },
  { id: 'QR', label: 'QR', icon: <QrCode2Icon /> },
  { id: 'products-link', label: 'WooCommerce Store Products', icon: <StorefrontIcon />, to: '/products' },
];

function App() {
  const dispatch = useDispatch()
  const dataVariable = useSelector((state) => state.user.dataVariable);
  const isLoading = useSelector((state) => state.user.isLoading);
  const [activeTab, setActiveTab] = useState('Option1');
  const [option, setOption] = useState("")
  const [atribute, setAtribute] = useState("")

  const handleChangeVariable = (index) => {
    setOption(dataVariable[index].option)
    setAtribute(dataVariable[index].variable)
  }

  const handleDelete = async (index) => {
    await dispatch(delVa({ id: dataVariable[index].id }))
    await dispatch(getVa())
  }

  useEffect(() => {
    dispatch(getVa())
  }, [dispatch])

  const renderContent = () => {
    switch (activeTab) {
      case 'Option1':
        return <Option1 option={option} setOption={setOption} atribute={atribute} setAtribute={setAtribute} />;
      case 'Option22':
        return <Option22 />;
      case 'UploadMoreImages':
        return <UploadMoreImages />;
      case 'ConvertImageFromSheet':
        return <ConvertImageFromSheet />;
      case 'ImageToFileFeed':
        return <ImageToFileFeed />;
      case 'QR':
        return <QR />;
      default:
        return <Option2 />;
    }
  }

  const dashboard = (
    <Box sx={{ display: 'flex', height: '100vh', backgroundColor: '#f5f5f5' }}>
      {isLoading && <LoadingScreen />}

      {/* AppBar */}
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: '#1976d2'
        }}
      >
        <Toolbar>
          <Typography variant="h6" noWrap component="div" sx={{ fontWeight: 'bold' }}>
            EGEAD Dashboard
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#ffffff',
            borderRight: '1px solid #e0e0e0',
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto', mt: 2 }}>
          <List>
            {menuItems.map((item) =>
              item.to ? (
                <ListItem key={item.id} disablePadding>
                  <ListItemButton
                    component={Link}
                    to={item.to}
                    sx={{
                      mx: 1,
                      mb: 0.5,
                      borderRadius: '8px',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                    }}
                  >
                    <Box sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
                      {item.icon}
                    </Box>
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                </ListItem>
              ) : (
                <ListItem key={item.id} disablePadding>
                  <ListItemButton
                    selected={activeTab === item.id}
                    onClick={() => setActiveTab(item.id)}
                    sx={{
                      mx: 1,
                      mb: 0.5,
                      borderRadius: '8px',
                      '&.Mui-selected': {
                        backgroundColor: '#E45F2B',
                        color: 'white',
                        '&:hover': {
                          backgroundColor: '#d14e1f',
                        },
                        '& .MuiListItemText-primary': {
                          fontWeight: 'bold',
                        },
                      },
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                    }}
                  >
                    <Box sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
                      {item.icon}
                    </Box>
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                </ListItem>
              )
            )}
          </List>

          {/* Variable List for Option1 */}
          {activeTab === 'Option1' && dataVariable.length > 0 && (
            <Box sx={{ mt: 4, px: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold', color: '#666' }}>
                Saved Variables
              </Typography>
              <List>
                {dataVariable.map((item, index) => (
                  <ListItem key={index} disablePadding>
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      position: 'relative',
                      mb: 0.5
                    }}>
                      <Button
                        fullWidth
                        onClick={() => handleChangeVariable(index)}
                        sx={{
                          justifyContent: 'flex-start',
                          textTransform: 'none',
                          backgroundColor: '#9AC1F0',
                          color: '#333',
                          borderRadius: '8px',
                          px: 2,
                          py: 1,
                          '&:hover': {
                            backgroundColor: '#7ab3f0',
                          },
                        }}
                      >
                        {item.name}
                      </Button>
                      <HighlightOffTwoToneIcon
                        sx={{
                          color: 'red',
                          position: 'absolute',
                          right: 8,
                          cursor: 'pointer',
                          '&:hover': {
                            color: '#d32f2f',
                          }
                        }}
                        onClick={() => handleDelete(index)}
                      />
                    </Box>
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
        </Box>
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 4,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          backgroundColor: '#f8f9fa',
          minHeight: '100vh',
        }}
      >
        <Toolbar />
        <Box sx={{ width: '100%', height: 'calc(100vh - 64px)', overflowY: 'auto' }}>
          {renderContent()}
        </Box>
      </Box>
    </Box>
  );

  return (
    <Routes>
      <Route path="/token" element={<Token />} />
      <Route path="/products" element={<WooStoreProducts />} />
      <Route path="*" element={dashboard} />
    </Routes>
  );
}

export default App;
